import { isEmpty } from 'ramda';

import { differenceInMinutes } from '@/lib/date';
import { getFlightDateTime } from '@/utils/mapDurationFromFlights';

const enrichWithStopOver = (flights) => {
  const result = [];

  flights.reduce((prevFlight, currFlight, i) => {
    if (isEmpty(prevFlight)) {
      result.push(currFlight);
      return currFlight;
    }

    const { arrival } = prevFlight;
    const { departure } = currFlight;

    const stopOverInMins = differenceInMinutes(
      getFlightDateTime(departure),
      getFlightDateTime(arrival),
    );
    const hours = Math.floor(stopOverInMins / 60);
    const days = Math.floor(hours / 24);
    const mins = stopOverInMins % 60;

    const stopOver = {
      days,
      hours,
      mins,
    };

    result.push({
      ...flights[i],
      stopOver,
    });

    return currFlight;
  }, {});

  return result;
};

export default enrichWithStopOver;
